/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import SendApplication from "./SendApplication";
import { Helmet } from "react-helmet-async";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import BenefitsLegalbirdTech from "./BenefitsLegalbirdTech";
import { gaSet } from "@/src/services/googleAnalyticsService";
import JobContainer, { JobContainerProps } from "@/src/components/Jobs/Job/JobContainer";

const seniorDeveloperJobDetails: JobContainerProps = {
  title: "Senior Developer (m/w/d)",
  hardFacts: [
    {
      title: "Standort",
      value: "Köln, DE",
    },
    {
      title: "Beschäftigungsart",
      value: "Vollzeit",
    },
    {
      title: "Arbeitsmodell",
      value: "Hybrid",
    },
    {
      title: "Bereich",
      value: "IT",
    },
  ],
  content: [
    {
      type: "text",
      text:
        "Mit unserer starken Onlinekompetenz, hoher juristischer Expertise und innovativer, AI-gestützter Automatisierung helfen wir dabei, rechtliche Fragestellungen " +
        "sicher, schnell und professionell online zu lösen.",
    },
    {
      type: "text",
      text:
        "Du hast Lust auf ein stark wachsendes Unternehmen und darauf, den Rechtsberatungsmarkt mit Hilfe modernster digitaler Technologien zu verändern? Du " +
        "ziehst es vor, in einem produktiven Umfeld zu arbeiten, in dem Du Projekte selbstverantwortlich in die Hand nehmen kannst? Du schätzt eine offene " +
        "Atmosphäre, in der es Spaß macht, über sich hinauszuwachsen? Dann bewirb Dich bei uns!",
    },
    {
      type: "headline",
      headline: "Was Deine Aufgaben sein werden",
    },
    {
      type: "list",
      items: [
        "Du entwickelst die Legalbird Platform in PHP und Javascript",
        "Du setzt anspruchsvolle Aufgaben in modernen Frameworks (Symfony/React) um",
        "Du achtest dabei auf Qualität, Wartbarkeit und Lesbarkeit und denkst langfristig",
        "Du hast den kompletten Stack im Blick vom Frontend bis zum Deployment",
      ],
    },
    {
      type: "headline",
      headline: "Was Du dazu brauchst",
    },
    {
      type: "list",
      items: [
        "Du begeisterst Dich für das Thema Softwareentwicklung und Architektur",
        "Mehrjährige Berufserfahrung in der Software-Entwicklung (PHP/Javascript) und mindestens ein professionelles Projekt unter Einsatz eines modernen Frameworks.",
        "Wünschenswert sind Erfahrungen im Bereich Symfony (PHP) und React (JS)",
        "Du kommunizierst in enger Abstimmung mit unseren Produktmanagern und kannst neue Features auf technischer Ebene diskutieren, planen und auf Tasks herunterbrechen.",
        "Du liebst Herausforderungen in Deinem Bereich und brennst dafür, diese optimal und kreativ zu lösen",
      ],
    },
  ],
  afterContent: (
    <>
      <BenefitsLegalbirdTech />
      <SendApplication to={"Andreas Quauke"} />
    </>
  ),
};

export default function SeniorDeveloper() {
  const title = "Jobs - Frontend Developer | Legalbird";

  gaSet({ title: title });

  return (
    <LayoutPublicRoutes>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <JobContainer {...seniorDeveloperJobDetails} />
    </LayoutPublicRoutes>
  );
}
